module.exports = global["searchandiser"] = require("-!/home/ubuntu/searchandiser-ui/node_modules/awesome-typescript-loader/dist/entry.js?{\"inlineSourceMap\":false,\"sourceMap\":true}!/home/ubuntu/searchandiser-ui/node_modules/source-map-loader/index.js!/home/ubuntu/searchandiser-ui/src/index.ts");


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.ts
 ** module id = 0
 ** module chunks = 0
 **/